import GradientTemperature from './GradientTemperature';

export default class GradientTemperatureInvalid implements GradientTemperature {
  public value = 'N/A';

  public textColor = '#000000';

  public backgroundColor = '#d5dce0';
}
